"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = ['[_nghost-%COMP%]{width:100%;font-size:14px;display:block}[_nghost-%COMP%]   span.required[_ngcontent-%COMP%]{color:red}'];
